import { combineReducers } from 'redux';
import { order } from './order_reducer';

const rootReducer = combineReducers({
  order
});

export default rootReducer;